/**
 * Symbol used to mark errors that have already been reported
 * to prevent duplicate reporting
 */
export const ErrorReported = Symbol('ErrorReported');

export interface ErrorWithReportedFlag extends Error {
  [ErrorReported]?: boolean;
}
